// @flow
import React, {PureComponent, type Node} from 'react';

import style from './error.scss';

type PropsType = {
    error: string,
};

/**
 * Display errors
 */
export default class Error extends PureComponent<PropsType> {
    /**
     * Render jsx to html
     *
     * @returns {Node} Rendered react component
     */
    render(): Node {
        return this.props.error.length > 0 ? (
            <div className={style.error} dangerouslySetInnerHTML={{__html: this.props.error}} />
        ) : null;
    }
}
